import React from 'react'
import PhotoIcon from '@material-ui/icons/Photo'

class FileIcon extends React.Component{
    mimeToIcon(mimeType,ext){
        let icon

        switch(true){
            //image file
            case mimeType.startsWith('image'):
                icon = "image"
            break

            //video file
            case mimeType.startsWith('video'):
                icon = "video"
            break

            //audio file
            case mimeType.startsWith('audio'):
                icon = "audio"
            break

            //pdf file
            case mimeType === 'application/pdf':
                icon = "pdf"
            break

            //word file
            case mimeType === 'application/msword':
            case mimeType === 'application/vnd.ms-word':
            case mimeType === 'application/vnd.oasis.opendocument.text':
            case mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                icon = "word"
            break

            //excel file
            case mimeType === 'text/csv':
            case mimeType === 'application/vnd.ms-excel':
            case mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            case mimeType === 'application/vnd.oasis.opendocument.spreadsheet':
                icon = "excel"
            break

            //powerpoint file
            case mimeType === 'application/vnd.ms-powerpoint':
            case mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            case mimeType === 'application/vnd.oasis.opendocument.presentation':
                icon = "powerpoint"
            break

            //zipped file
            case mimeType === 'application/zip':
            case mimeType === 'application/x-rar-compressed':
            case mimeType === 'application/x-zip-compressed':
            case mimeType === 'application/octet-stream' && ext === "7z":
                icon = "zipper"
            break
            case mimeType === 'application/octet-stream':
                icon = "code"
            break

            //html file
            case mimeType === 'text/html':
                icon = "code"
            break

            case mimeType === 'default': 
            default: 
                icon = "default"
            break
        }

        return icon
    }

    render(){
        const ext = this.props.hasOwnProperty('ext')
            ? this.props.ext
            : ""
        const mime_type = this.props.hasOwnProperty('mime_type')
            ? this.props.mime_type
            : ""
        const width = this.props.hasOwnProperty('width') 
            ? this.props.width 
            : 22
        const height = this.props.hasOwnProperty('height') 
            ? this.props.height 
            : 22

        
        try {
            const icon = this.mimeToIcon(mime_type,ext)
            const img = require(`../images/${icon}.svg`)
            return <img src={img}
                width={width}
                height={height}
                alt={mime_type}
            />
        }
        catch (e) {
            return <PhotoIcon />
        }
    }
}
export default FileIcon